import React from "react";
import useStyles from "./styles";

const NotFoundPage = () => {
  const classes = useStyles();

  return <div className={classes.component}>Page Not Found (404)</div>;
};

export default NotFoundPage;
